export const ADFOX_TIMEOUT = 2000;
